import { TradingPlansTable } from '../../components/tables/Tables';
import { useEffect, useState } from 'react';
import axios from 'axios';
import secureLocalStorage from 'react-secure-storage';
import { PageSpinner } from '../../components/spinner/Spinner';
import NothingToSeeHere from '../../components/nothing-to-see-here/NothingToSeeHere';
import { config } from '../../Constants';
import { FaPlus } from 'react-icons/fa';
import { useDisclosure } from '@mantine/hooks';
import { AddTradingPlanModal } from '../../components/modals/Modals';

const TradingPlans = () => {
  const [data, setData] = useState({});
  const { token } = JSON.parse(secureLocalStorage.getItem(`user-info`));
  const [loading, setLoading] = useState(true);
  const [opened, { open, close }] = useDisclosure(false);
  const baseURL = config.baseURL;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await axios.get(`${baseURL}/trading-plans`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setLoading(false);
        setData(data);
      } catch (error) {
        setLoading(false);
      }
    };
    fetchData();
    // eslint-disable-next-line
  }, []);

  return (
    <main className='content trading-plans-page'>
      <div className='title-btn'>
        <h1 className='title'>Trading Plans</h1>
        <button className='primary' onClick={open}>
          <FaPlus /> Add Trading Plan
        </button>
      </div>
      {loading ? (
        <PageSpinner />
      ) : !loading && data.length > 0 ? (
        <TradingPlansTable data={data} />
      ) : (
        <NothingToSeeHere />
      )}
      <AddTradingPlanModal close={close} opened={opened} />
    </main>
  );
};

export default TradingPlans;
